import React from 'react';

interface ProfilePictureProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'alt'> {
    name: string;
}

/** The portrait's look. The caller sets its size through `className`. */
const ProfilePicture: React.FC<ProfilePictureProps> = ({ name, className = '', ...props }) => (
    <img
        alt={`Portrait of ${name}`}
        className={`object-cover rounded-2xl shrink-0 ring-1 ring-ink-200 dark:ring-ink-700 ${className}`}
        {...props}
    />
);

export default ProfilePicture;
